export var Name = 'user-logout-confirmation';
export var UserLogoutConfirmationEvent = Name;